import { FC } from 'react';
import intl from 'react-intl-universal';
import { Button, tailwindOverride } from '@getsynapse/design-system';
import { useLanguage } from 'Organisms/LanguageModal/LanguageContext';
import openProjectsEmptyState from 'assets/images/open-projects-empty-state.svg';
import RenderNoRecords from 'Atoms/NoRecords/NoRecords';
import {
  ACTIVE_PROJECTS_TABLE_SORTABLE_COLUMNS,
  CONSOLIDATED_PROJECTS_TABLE_SORTABLE_COLUMNS,
} from 'utils/constants/projectsList';

interface EmptyProjectsTableProps {
  addNewProject?: () => void;
  emptyFilters?: boolean;
  emptySearch?: boolean;
  isConsolidatedView?: boolean;
}

const EmptyProjectsTable: FC<EmptyProjectsTableProps> = ({
  addNewProject,
  emptySearch = true,
  emptyFilters = true,
  isConsolidatedView = false,
}) => {
  const { currentLocale } = useLanguage();
  const columnSpan = isConsolidatedView
    ? CONSOLIDATED_PROJECTS_TABLE_SORTABLE_COLUMNS.length
    : ACTIVE_PROJECTS_TABLE_SORTABLE_COLUMNS.length;

  if (!emptySearch || !emptyFilters) {
    return (
      <tr>
        <td colSpan={columnSpan}>
          <RenderNoRecords
            imageSrc={openProjectsEmptyState}
            imageAlt={intl.get('PROJECTS_LIST_PAGE.EMPTY_STATE.FILTER')}
            className={tailwindOverride('h-empty-table-body', {
              'empty-forms-table-body': !emptyFilters,
            })}
          >
            <div
              className={tailwindOverride(
                'flex flex-wrap w-full text-center mt-4',
                {
                  'max-w-xs': currentLocale === 'en',
                  'max-w-sm': currentLocale === 'fr',
                }
              )}
            >
              <span className='w-full whitespace-normal text-base text-primary font-normal'>
                {intl.get('PROJECTS_LIST_PAGE.EMPTY_STATE.FILTER')}
              </span>
            </div>
          </RenderNoRecords>
        </td>
      </tr>
    );
  }

  return (
    <tr>
      <td colSpan={columnSpan}>
        <RenderNoRecords
          imageSrc={openProjectsEmptyState}
          className='h-empty-table-body'
          wrapperClassName='w-72'
        >
          <div className='flex flex-wrap w-full max-w-xs text-center mt-4'>
            <span className='w-full whitespace-normal text-base text-primary font-normal'>
              {intl.get('PROJECTS_LIST_PAGE.EMPTY_STATE.DEFAULT')}
            </span>
          </div>
          <Button className='mt-2 mx-auto' onClick={addNewProject}>
            {intl.get('PROJECTS_LIST_PAGE.CREATE_PROJECT_MODAL.TITLE')}
          </Button>
        </RenderNoRecords>
      </td>
    </tr>
  );
};

export default EmptyProjectsTable;
